import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import interior1 from '../images/interior-seagull-1.jpg';
import interior2 from '../images/interior-seagull-2.jpg';
import interior3 from '../images/interior-seagull-3.jpg';
import interior4 from '../images/interior-seagull-4.jpg';
import interior5 from '../images/interior-seagull-5.jpg';
import interior6 from '../images/interior-seagull-6.jpg';
import interior7 from '../images/interior-seagull-7.jpg';
import interior8 from '../images/interior-seagull-8.jpg';

function InteriorSeagull() {
  const interiors = [
    {
      image: interior1,
      title: '🎛️ Layar Sentuh Utama & Dashboard Futuristik',
      desc: 'Layar sentuh menjadi pusat kendali infotainment dan pengaturan kendaraan BYD Atto 1. Layout dashboard dibuat ringkas agar informasi utama mudah dijangkau saat digunakan sehari-hari.',
    },
    {
      image: interior2,
      title: 'Wireless Charging pada Varian Premium',
      desc: 'Varian Premium menyediakan wireless charging untuk membantu pengemudi mengisi daya smartphone secara praktis di area konsol tengah.',
    },
    {
      image: interior3,
      title: 'Area Kontrol Kabin',
      desc: 'Atto 1 NIK 2026 menggunakan shift by wire di area steering column. Perubahan ini membuat konsol tengah lebih lega dan kontrol utama tetap mudah dijangkau.',
    },
    {
      image: interior4,
      title: 'Jok Depan dan Posisi Duduk',
      desc: 'Jok depan dirancang untuk menopang posisi duduk pengemudi dan penumpang. Pengemudi juga mendapatkan pengaturan kursi elektrik 6-way pada Dynamic dan Premium NIK 2026.',
    },
    {
      image: interior5,
      title: '🛋️ Jok Belakang Lapang & Stylish',
      desc: 'Ruang kabin belakang dirancang untuk tiga penumpang dengan layout yang mendukung kebutuhan perjalanan harian. Kursi belakang juga dapat dilipat saat membutuhkan ruang barang tambahan.',
    },
    {
      image: interior6,
      title: '💺 Pengaturan Jok Elektrik',
      desc: 'Pengaturan kursi pengemudi elektrik 6-way tersedia pada Dynamic dan Premium NIK 2026 untuk memudahkan penyesuaian posisi berkendara.',
    },
    {
      image: interior7,
      title: '🧳 Bagasi Fleksibel & Bisa Diperluas',
      desc: 'Bagasi BYD Atto 1 dapat diperluas dengan melipat kursi belakang, sehingga lebih fleksibel untuk membawa barang belanja atau perlengkapan perjalanan.',
    },
    {
      image: interior8,
      title: '🖥️ Tampilan Interior Minimalis Modern',
      desc: 'Secara keseluruhan, interior BYD Atto 1 memakai layout modern dan ringkas. Dashboard, layar, ruang penyimpanan, dan kontrol utama disusun untuk kebutuhan mobilitas harian.',
    },
  ];

  return (
    <Box
      sx={{ padding: { xs: 2, sm: 4 }, maxWidth: '1200px', margin: '0 auto' }}
    >
      <Helmet>
        <title>
          Interior BYD Atto 1 NIK 2026 | Dashboard, Kursi & Fitur
        </title>
        <meta
          name='description'
          content='Lihat interior BYD Atto 1 NIK 2026: dashboard, layar sentuh, shift by wire, kursi pengemudi elektrik 6-way, kabin belakang, dan wireless charging Premium.'
        />
        <meta
          name='keywords'
          content='interior BYD Atto 1 NIK 2026, dashboard BYD Atto 1, kursi elektrik BYD Atto 1, shift by wire Atto 1, BYD BSD Serpong'
        />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/interior-byd-atto1'
        />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        Interior BYD Atto 1 NIK 2026
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        BYD Atto 1 NIK 2026 memiliki kabin ringkas untuk penggunaan harian,
        dilengkapi layar sentuh, shift by wire, pengaturan kursi pengemudi
        elektrik 6-way, dan ruang kabin yang fleksibel. Fitur tertentu dapat
        berbeda antara Dynamic dan Premium.
      </Typography>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        {interiors.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
              <Box
                component='img'
                src={item.image}
                alt={item.title}
                sx={{ width: '100%', maxHeight: 500, objectFit: 'cover' }}
              />
              <Box sx={{ padding: 3 }}>
                <Typography variant='h5' fontWeight='bold' gutterBottom>
                  {item.title}
                </Typography>
                <Typography
                  variant='body1'
                  sx={{ fontSize: '1.05rem', lineHeight: 1.8 }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          FAQ Interior BYD Atto 1
        </Typography>
        <Typography variant='h6' fontWeight='bold' mt={3}>
          Apakah interior BYD Atto 1 terasa sempit?
        </Typography>
        <Typography paragraph>
          Justru sebaliknya! Walaupun eksteriornya compact, desain interior BYD
          Atto 1 dirancang untuk memberi kesan lapang dengan layout ergonomis
          dan fitur-fitur ringkas namun fungsional.
        </Typography>

        <Typography variant='h6' fontWeight='bold' mt={3}>
          ❓ Apakah jok kulit asli?
        </Typography>
        <Typography paragraph>
          Material yang digunakan adalah kulit sintetis berkualitas tinggi yang
          mudah dibersihkan dan tetap nyaman untuk penggunaan jangka panjang.
        </Typography>

        <Typography variant='h6' fontWeight='bold' mt={3}>
          ❓ Bisa muat banyak barang?
        </Typography>
        <Typography paragraph>
          Yes! Bagasi bisa diperluas dengan melipat kursi belakang. Cocok buat
          kamu yang suka road trip atau bawa perlengkapan belanja mingguan.
        </Typography>
      </Box>

      <Box sx={{ mt: 6 }}>
        <Paper
          sx={{
            padding: 4,
            backgroundColor: '#e3f2fd',
            borderLeft: '6px solid #1976d2',
          }}
        >
          <Typography variant='h5' fontWeight='bold' gutterBottom>
            Ingin Lihat Langsung Interior BYD Atto 1?
          </Typography>
          <Typography variant='body1' paragraph>
            Segera hubungi kami untuk jadwal test drive atau pre-order! Interior
            stylish, fitur canggih, dan kenyamanan maksimal—semuanya bisa kamu
            rasakan langsung.
          </Typography>
          <Typography variant='body2'>
            📞{' '}
            <a
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20tertarik%20melihat%20interior%20BYD%20Atto%201%20NIK%202026'
              target='_blank'
              rel='noopener noreferrer'
            >
              Chat via WhatsApp
            </a>{' '}
            atau follow kami di{' '}
            <a
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              rel='noopener noreferrer'
            >
              @bydbsdserpong
            </a>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default InteriorSeagull;
